// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: light;
  --bb-bg: #eef5f1;
  --bb-bg-elevated: #ffffff;
  --bb-bg-soft: #f4f8f5;
  --bb-bg-glass: rgba(255, 255, 255, 0.9);
  --bb-border: rgba(20, 83, 45, 0.12);
  --bb-border-soft: rgba(20, 83, 45, 0.1);
  --bb-text: #102018;
  --bb-muted: #5a6b62;
  --bb-faint: #8a9a92;
  --bb-brand: #179b6d;
  --bb-brand-deep: #14532d;
  --bb-brand-soft: rgba(23, 155, 109, 0.12);
  --bb-market: #179b6d;
  --bb-execution: #146c4c;
  --bb-indicators: #0f766e;
  --bb-conditions: #f59e0b;
  --bb-restart: #8b5cf6;
  --bb-utility: #5f6f68;
  --bb-success: #16a34a;
  --bb-warning: #facc15;
  --bb-danger: #ef4444;
  --bb-radius: 24px;
  --bb-radius-sm: 18px;
  --bb-radius-xs: 12px;
  --block-header-bg: var(--bb-brand);
  --block-header-fg: #ffffff;
  --block-body-bg: #ffffff;
  --block-body-alt: #f7fbf8;
  --block-border: rgba(20, 83, 45, 0.12);
  --block-radius: 10px;
  --block-notch-size: 9px;
  --block-shell-padding: 12px;
  font-family: "Manrope", sans-serif;
}

:root.dark {
  color-scheme: dark;
  --bb-bg: #09140f;
  --bb-bg-elevated: #0d1b15;
  --bb-bg-soft: #102119;
  --bb-bg-glass: rgba(9, 20, 15, 0.9);
  --bb-border: rgba(167, 243, 208, 0.12);
  --bb-border-soft: rgba(167, 243, 208, 0.08);
  --bb-text: #e8f4ef;
  --bb-muted: #9fb1a8;
  --bb-faint: #72877d;
  --bb-brand: #1db57f;
  --bb-brand-deep: #169368;
  --bb-brand-soft: rgba(29, 181, 127, 0.14);
  --block-header-bg: #1db57f;
  --block-header-fg: #08110d;
  --block-body-bg: #0e1713;
  --block-body-alt: #101c17;
  --block-border: rgba(167, 243, 208, 0.14);
}

* {
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  min-height: 100%;
}

body {
  margin: 0;
  font-family: "Manrope", sans-serif;
  color: var(--bb-text);
  background:
    radial-gradient(circle at top left, rgba(23, 155, 109, 0.12), transparent 28%),
    radial-gradient(circle at top right, rgba(20, 83, 45, 0.08), transparent 24%),
    linear-gradient(180deg, var(--bb-bg) 0%, color-mix(in srgb, var(--bb-bg) 88%, #ffffff) 100%);
  overflow: hidden;
}

button,
input,
select,
textarea {
  font: inherit;
}

button {
  border: 0;
}

#app {
  width: 100%;
  height: 100svh;
  min-height: 100svh;
}

.bb-app {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 0;
  padding: 0;
}

.bb-topbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  padding: 10px 18px;
  border: 0;
  border-bottom: 1px solid var(--bb-border-soft);
  border-radius: 0;
  background: var(--bb-bg-glass);
  box-shadow: none;
  backdrop-filter: none;
}

.bb-topbar-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.bb-brand-mark {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 18px;
  color: #ffffff;
  background: linear-gradient(180deg, var(--bb-brand) 0%, var(--bb-brand-deep) 100%);
  font-weight: 800;
  letter-spacing: 0.08em;
}

.bb-topbar-brand strong {
  display: block;
  font-size: 18px;
  line-height: 1.1;
}

.bb-topbar-brand span {
  display: block;
  color: var(--bb-muted);
  font-size: 12px;
}

.bb-topbar-center {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex: 1 1 320px;
  min-width: 0;
}

.bb-market-picker {
  display: grid;
  gap: 6px;
  min-width: 240px;
}

.bb-market-picker span {
  color: var(--bb-muted);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.bb-market-picker select {
  width: 100%;
  min-height: 42px;
  padding: 0 14px;
  color: var(--bb-text);
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
  border-radius: 18px;
  outline: none;
  box-shadow: none;
}

.bb-market-picker input {
  width: 100%;
  min-height: 42px;
  padding: 0 14px;
  color: var(--bb-text);
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
  border-radius: 18px;
  outline: none;
  box-shadow: none;
}

.bb-token-picker {
  min-width: 280px;
}

.bb-topbar-status {
  min-height: 42px;
  display: inline-grid;
  gap: 2px;
  align-items: center;
  padding: 8px 14px;
  border-radius: 999px;
  color: var(--bb-brand-deep);
  background: var(--bb-brand-soft);
  border: 1px solid color-mix(in srgb, var(--bb-brand) 22%, transparent);
}

.bb-topbar-status-label {
  color: var(--bb-brand-deep);
  font-size: 13px;
  font-weight: 800;
  line-height: 1.1;
}

.bb-topbar-status-label.is-ready {
  color: var(--bb-brand-deep);
}

.bb-topbar-status-label.is-running {
  color: var(--bb-brand);
}

.bb-topbar-status-label.is-error {
  color: #991b1b;
}

.bb-topbar-status-note {
  color: #4b5563;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.2;
}

.bb-topbar-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  margin-left: auto;
}

.bb-btn {
  min-height: 42px;
  padding: 0 16px;
  border-radius: 16px;
  cursor: pointer;
  color: var(--block-header-fg);
  font-weight: 800;
  letter-spacing: 0.01em;
  box-shadow: none;
  transition: transform 0.18s ease, opacity 0.18s ease, border-color 0.18s ease;
}

.bb-btn-sm {
  min-height: 34px;
  padding: 0 12px;
  border-radius: 12px;
  font-size: 12px;
}

.bb-btn:hover {
  transform: translateY(-1px);
}

.bb-btn:active {
  transform: translateY(0);
  opacity: 0.92;
}

.bb-btn-success {
  background: var(--bb-brand);
}

.bb-btn-warn {
  color: #ffffff;
  background: #2f855a;
}

.bb-btn-primary {
  background: var(--bb-brand);
}

.bb-btn-secondary {
  background: #64748b;
}

.bb-btn-danger {
  background: #ef4444;
}

.bb-layout {
  display: grid;
  grid-template-columns: minmax(208px, 238px) minmax(0, 1fr) minmax(248px, 294px);
  gap: 16px;
  padding: 14px 16px 0;
  min-height: 0;
  align-items: stretch;
}

.bb-sidebar,
.bb-inspector {
  display: grid;
  gap: 14px;
  align-content: start;
  min-height: 0;
}

.bb-panel,
.bb-card {
  padding: 16px;
  border: 1px solid var(--bb-border-soft);
  border-radius: 24px;
  background: var(--bb-bg-glass);
  box-shadow: none;
}

.bb-sidebar-intro p,
.bb-sidebar-footnote p,
.bb-tip-card p {
  margin: 0;
  color: var(--bb-muted);
  line-height: 1.55;
  font-size: 13px;
}

.bb-panel-title,
.bb-card-title {
  margin-bottom: 12px;
  color: #111827;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 800;
}

.bb-category-list {
  display: grid;
  gap: 10px;
}

.bb-category-accordion {
  display: grid;
  gap: 0;
}

.bb-category-card {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
  align-items: center;
  width: 100%;
  padding: 12px 13px;
  color: var(--bb-text);
  text-align: left;
  border: 1px solid var(--bb-border-soft);
  border-radius: 18px;
  background: linear-gradient(180deg, var(--bb-bg-elevated), var(--block-body-alt));
  cursor: pointer;
  transition:
    transform 0.18s ease,
    border-color 0.18s ease,
    background 0.18s ease;
}

.bb-category-card:hover,
.bb-category-card.is-active {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--category-accent) 48%, transparent);
  background: linear-gradient(180deg, var(--bb-bg-elevated), var(--block-body-alt));
}

.bb-category-card.is-active {
  box-shadow: none;
}

.bb-category-copy strong {
  display: block;
  font-size: 15px;
}


.bb-workbench {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 14px;
  min-width: 0;
  min-height: 0;
  height: 100%;
}

.bb-workbench-header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 18px;
  padding: 8px 8px 0;
}

.bb-workbench-kicker {
  color: var(--bb-brand);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 11px;
  font-weight: 800;
}

.bb-workbench-header h2 {
  margin: 6px 0 6px;
  font-size: 22px;
  line-height: 1.1;
}

.bb-workbench-header p {
  margin: 0;
  max-width: 62ch;
  color: var(--bb-muted);
  font-size: 13px;
  line-height: 1.55;
}

.bb-workbench-flow {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.bb-workbench-flow span {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  border: 1px solid transparent;
}

.bb-workbench-flow .is-market {
  color: var(--bb-brand-deep);
  background: var(--bb-brand-soft);
  border-color: color-mix(in srgb, var(--bb-brand) 18%, transparent);
}

.bb-workbench-flow .is-execution {
  color: #14532d;
  background: rgba(20, 83, 45, 0.08);
  border-color: rgba(20, 83, 45, 0.18);
}

.bb-workbench-flow .is-conditions {
  color: #92400e;
  background: rgba(245, 158, 11, 0.1);
  border-color: rgba(245, 158, 11, 0.18);
}

.bb-workbench-flow .is-restart {
  color: #5b6472;
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.2);
}

.bb-workspace-shell {
  position: relative;
  min-height: 0;
  height: 100%;
  min-height: clamp(560px, 66svh, 860px);
  padding: 12px;
  border: 1px solid color-mix(in srgb, var(--bb-brand) 14%, var(--bb-border-soft));
  border-radius: 28px;
  background:
    radial-gradient(circle at top left, rgba(23, 155, 109, 0.1), transparent 26%),
    radial-gradient(circle at top right, rgba(20, 83, 45, 0.08), transparent 22%),
    radial-gradient(circle at bottom left, rgba(245, 158, 11, 0.05), transparent 20%),
    linear-gradient(180deg, color-mix(in srgb, var(--bb-bg) 94%, #ffffff) 0%, color-mix(in srgb, var(--bb-bg) 84%, #ffffff) 48%, color-mix(in srgb, var(--bb-bg) 78%, #ffffff) 100%),
    linear-gradient(rgba(15, 23, 42, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(15, 23, 42, 0.03) 1px, transparent 1px);
  background-size: auto, auto, auto, auto, 38px 38px, 38px 38px;
  background-position: 0 0, 100% 100%, 0 0, 0 0, 0 0, 0 0;
  box-shadow: none;
  overflow: hidden;
}

.bb-workspace {
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 22px;
  touch-action: none;
}

.bb-workspace .blocklyMainBackground {
  fill: rgba(255, 255, 255, 0.68) !important;
}

.bb-workspace .blocklySvg {
  border-radius: 24px;
}

.bb-workspace .blocklyToolboxDiv,
.bb-workspace .blocklyFlyout,
.bb-workspace .blocklyFlyoutBackground {
  display: none !important;
}

.bb-workspace .blocklyScrollbarVertical,
.bb-workspace .blocklyScrollbarHorizontal {
  opacity: 0.78;
}

.bb-workspace .blocklyFlyoutBackground {
  fill: rgba(255, 255, 255, 0.92) !important;
}

/* Keep Blockly's puzzle geometry, but give each block the layered Deriv-style card treatment. */
.bb-workspace .bb-block .blocklyPath {
  stroke-width: 1.2px !important;
  vector-effect: non-scaling-stroke;
}

.bb-workspace .bb-block-section .blocklyPath {
  fill: var(--bb-brand-deep) !important;
  stroke: color-mix(in srgb, var(--bb-brand-deep) 82%, #06130d) !important;
}

.bb-workspace .bb-block-card .blocklyPath {
  fill: var(--block-body-alt) !important;
  stroke: color-mix(in srgb, var(--bb-brand-deep) 28%, #ffffff) !important;
}

.bb-workspace .bb-block-section .blocklyText {
  fill: #ffffff !important;
  font-family: "Manrope", sans-serif !important;
  font-weight: 700 !important;
}

.bb-workspace .bb-block-card .blocklyText {
  fill: var(--bb-text) !important;
  font-family: "Manrope", sans-serif !important;
  font-weight: 700 !important;
}

.bb-workspace .bb-block-section .blocklyText {
  font-size: 11px !important;
  letter-spacing: 0.02em;
}

.bb-workspace .bb-block-card .blocklyText {
  font-size: 10px !important;
}

.bb-workspace .bb-block .blocklyEditableText rect,
.bb-workspace .bb-block .blocklyFieldRect {
  fill: var(--bb-bg-elevated) !important;
  stroke: rgba(20, 83, 45, 0.18) !important;
  rx: 5px;
  ry: 5px;
}

.bb-workspace .bb-block .blocklyEditableText text,
.bb-workspace .bb-block .blocklyDropdownText,
.bb-workspace .bb-block .blocklyCheckboxText {
  fill: var(--bb-text) !important;
  font-weight: 700 !important;
}

.bb-workspace .bb-block .blocklyDropdownArrow {
  fill: var(--bb-brand-deep) !important;
}

.bb-workspace .bb-block .blocklyConnectionIndicator,
.bb-workspace .bb-block .blocklyConnectionHighlight {
  stroke: var(--bb-warning) !important;
}

.bb-workspace .bb-block.blocklySelected .blocklyPath {
  stroke: var(--bb-warning) !important;
  stroke-width: 2.4px !important;
}

.bb-workspace .bb-block:not(.bb-block-section) {
  filter: none;
}

:root.dark .bb-workspace .bb-block .blocklyEditableText rect,
:root.dark .bb-workspace .bb-block .blocklyFieldRect {
  stroke: rgba(167, 243, 208, 0.22) !important;
}

.bb-inspector {
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
  padding-right: 4px;
}

.bb-status-pill {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.bb-status-pill.is-ready {
  color: #14532d;
  background: rgba(220, 252, 231, 0.72);
  border: 1px solid rgba(22, 163, 74, 0.26);
}

.bb-status-pill.is-error {
  color: #991b1b;
  background: rgba(254, 226, 226, 0.9);
  border: 1px solid rgba(239, 68, 68, 0.24);
}

.bb-status-caption {
  margin-top: 12px;
  color: var(--bb-muted);
  font-size: 13px;
  line-height: 1.55;
}

.bb-condition-engine {
  display: grid;
  gap: 10px;
  color: var(--bb-text);
  font-size: 12px;
  line-height: 1.45;
}

.bb-engine-summary {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.bb-engine-summary > div,
.bb-engine-hint,
.bb-engine-empty,
.bb-engine-warning-list,
.bb-engine-row,
.bb-engine-detail,
.bb-engine-warning {
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: var(--bb-bg-elevated);
}

.bb-engine-summary strong,
.bb-engine-row strong {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 4px;
}

.bb-engine-rules {
  display: grid;
  gap: 8px;
}

.bb-engine-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-top: -2px;
  color: var(--bb-muted);
  font-size: 11px;
}

.bb-engine-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.bb-engine-row.is-ready {
  border-color: rgba(22, 163, 74, 0.2);
  background: rgba(220, 252, 231, 0.5);
}

.bb-engine-row.is-running {
  border-color: rgba(23, 155, 109, 0.2);
  background: rgba(236, 253, 245, 0.7);
}

.bb-engine-row.is-error {
  border-color: rgba(239, 68, 68, 0.18);
  background: rgba(254, 226, 226, 0.55);
}

.bb-engine-detail,
.bb-engine-warning {
  margin-top: 6px;
  color: var(--bb-muted);
}

.bb-engine-warning {
  color: #b45309;
  background: rgba(254, 243, 199, 0.75);
}

.bb-engine-blocked {
  display: grid;
  gap: 8px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid rgba(239, 68, 68, 0.18);
  background: rgba(254, 226, 226, 0.45);
}

.bb-engine-blocked-title {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 900;
  color: #991b1b;
}

.bb-engine-blocked-row {
  display: grid;
  gap: 4px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
}

.bb-engine-blocked-row strong {
  font-size: 12px;
}

.bb-engine-warning-list {
  display: grid;
  gap: 6px;
  color: #92400e;
  background: rgba(254, 243, 199, 0.45);
}

.bb-pre {
  margin: 0;
  max-height: 200px;
  overflow: auto;
  padding: 14px;
  color: #111827;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  background: var(--bb-bg-soft);
}

.bb-results {
  min-height: 84px;
  padding: 14px;
  border-radius: 14px;
  color: var(--bb-text);
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: var(--bb-bg-soft);
}

.bb-final-banner {
  display: grid;
  gap: 6px;
  margin-bottom: 14px;
  padding: 14px 16px;
  border-radius: 16px;
  border: 1px solid rgba(148, 163, 184, 0.2);
  background: rgba(255, 255, 255, 0.96);
}

.bb-final-banner-label {
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0.02em;
}

.bb-final-banner-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  color: var(--bb-muted);
  font-size: 12px;
  font-weight: 700;
}

.bb-final-banner.is-ready {
  border-color: rgba(22, 163, 74, 0.24);
  background: linear-gradient(180deg, rgba(220, 252, 231, 0.95), rgba(255, 255, 255, 0.98));
}

.bb-final-banner.is-error {
  border-color: rgba(239, 68, 68, 0.24);
  background: linear-gradient(180deg, rgba(254, 226, 226, 0.95), rgba(255, 255, 255, 0.98));
}

.bb-trade-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.bb-trade-summary-item {
  display: grid;
  gap: 6px;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid rgba(20, 83, 45, 0.12);
  background: rgba(255, 255, 255, 0.94);
}

.bb-trade-summary-item span {
  color: var(--bb-muted);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.bb-trade-summary-item strong {
  color: var(--bb-text);
  font-size: 14px;
  font-weight: 800;
}

.bb-trade-summary-badge {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.bb-trade-summary-badge.is-ready {
  color: #14532d;
  background: rgba(220, 252, 231, 0.9);
}

.bb-trade-summary-badge.is-running {
  color: var(--bb-brand-deep);
  background: rgba(236, 253, 245, 0.9);
}

.bb-trade-summary-badge.is-error {
  color: #991b1b;
  background: rgba(254, 226, 226, 0.9);
}

.bb-result-ok {
  color: var(--bb-brand);
  font-weight: 800;
}

.bb-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.bb-result-outcome {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.02em;
}

.bb-result-outcome.is-ready {
  color: #14532d;
  background: rgba(220, 252, 231, 0.9);
}

.bb-result-outcome.is-running {
  color: var(--bb-brand-deep);
  background: rgba(236, 253, 245, 0.9);
}

.bb-result-outcome.is-error {
  color: #991b1b;
  background: rgba(254, 226, 226, 0.9);
}

.bb-result-error {
  color: #fecaca;
  font-weight: 800;
}

.bb-result-meta {
  display: grid;
  gap: 10px;
  margin-top: 12px;
}

.bb-result-meta div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  color: var(--bb-muted);
  font-size: 12px;
}

.bb-result-meta strong {
  color: #e2e8f0;
  font-size: 12px;
}

.bb-result-list {
  display: grid;
  gap: 8px;
  margin-top: 12px;
  color: #fecaca;
  font-size: 13px;
}

.bb-result-caption {
  margin-top: 10px;
  color: var(--bb-muted);
  font-size: 13px;
}

.bb-settled-note {
  margin-top: 14px;
  padding: 12px 14px;
  border-radius: 14px;
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  background: rgba(236, 253, 245, 0.8);
  border: 1px dashed rgba(23, 155, 109, 0.28);
}

.bb-lifecycle-list {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.bb-lifecycle-row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 12px;
  align-items: start;
  padding: 12px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.62);
  border: 1px solid rgba(20, 83, 45, 0.08);
}

.bb-lifecycle-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 84px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.bb-lifecycle-badge.is-ready {
  color: #14532d;
  background: rgba(220, 252, 231, 0.9);
}

.bb-lifecycle-badge.is-running {
  color: var(--bb-brand-deep);
  background: rgba(236, 253, 245, 0.9);
}

.bb-lifecycle-badge.is-pending {
  color: #92400e;
  background: #fef3c7;
}

.bb-lifecycle-body {
  display: grid;
  gap: 8px;
}

.bb-lifecycle-title {
  color: var(--bb-text);
  font-size: 13px;
  line-height: 1.5;
}

.bb-lifecycle-details {
  margin-top: 2px;
  padding: 10px 12px;
  border-radius: 14px;
  border: 1px solid rgba(20, 83, 45, 0.12);
  background: rgba(255, 255, 255, 0.94);
}

.bb-lifecycle-details summary {
  cursor: pointer;
  color: var(--bb-muted);
  font-size: 12px;
  font-weight: 800;
}

.bb-lifecycle-raw {
  margin: 10px 0 0;
  max-height: 220px;
  overflow: auto;
  padding: 12px;
  border-radius: 12px;
  background: #0b1712;
  color: #e3f0ea;
  font-size: 11px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.bb-event-log {
  margin-top: 14px;
  padding: 14px;
  border-radius: 16px;
  border: 1px solid rgba(20, 83, 45, 0.12);
  background: rgba(255, 255, 255, 0.58);
}

.bb-event-log-title {
  color: var(--bb-muted);
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.bb-event-log-list {
  display: grid;
  gap: 10px;
  margin-top: 12px;
}

.bb-event-log-row {
  display: grid;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(20, 83, 45, 0.1);
}

.bb-event-log-time,
.bb-event-log-name {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.bb-event-log-time {
  color: #64748b;
}

.bb-event-log-name {
  color: var(--bb-brand);
}

.bb-event-log-payload {
  margin: 0;
  padding: 10px;
  overflow: auto;
  border-radius: 12px;
  background: #0b1712;
  color: #e3f0ea;
  font-size: 11px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}

.bb-event-log-empty {
  color: var(--bb-muted);
  font-size: 12px;
  font-style: italic;
}

.bb-tip-card p {
  margin: 0;
}

.bb-modal {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: none;
}

.bb-modal.is-open {
  display: block;
}

.bb-modal-shell {
  position: fixed;
  top: 80px;
  left: clamp(280px, 22vw, 380px);
  width: min(520px, calc(100vw - 320px));
  height: min(540px, calc(100vh - 110px));
  margin: 0;
  display: grid;
  grid-template-rows: auto auto minmax(0, 1fr);
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--bb-border);
  border-radius: 26px;
  background: var(--bb-bg-glass);
  box-shadow: none;
}

.bb-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.bb-modal-kicker {
  color: var(--bb-brand);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 11px;
  font-weight: 800;
}

.bb-modal-header h3 {
  margin: 6px 0 4px;
  font-size: 18px;
}

.bb-modal-header p {
  margin: 0;
  max-width: 52ch;
  color: var(--bb-muted);
  line-height: 1.45;
  font-size: 12px;
}

.bb-icon-btn {
  min-height: 40px;
  padding: 0 14px;
  border-radius: 14px;
  color: var(--bb-text);
  cursor: pointer;
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
}

.bb-modal-toolbar {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 12px;
}

.bb-search {
  display: grid;
  gap: 6px;
  flex: 1;
}

.bb-search span {
  color: var(--bb-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 11px;
  font-weight: 800;
}

.bb-search input {
  min-height: 40px;
  padding: 0 14px;
  color: var(--bb-text);
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border);
  border-radius: 18px;
  outline: none;
}

.bb-modal-count {
  color: var(--bb-muted);
  font-size: 12px;
  font-weight: 700;
}

.bb-modal-body {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(180px, 0.42fr);
  gap: 8px;
  min-height: 0;
}

.bb-modal-list,
.bb-modal-detail {
  min-height: 0;
  overflow: auto;
  padding-right: 2px;
}

.bb-modal-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.bb-modal-guidance {
  grid-column: 1 / -1;
  display: grid;
  gap: 3px;
  padding: 12px 14px;
  border: 1px solid rgba(23, 155, 109, 0.22);
  border-radius: 20px;
  background: linear-gradient(180deg, rgba(236, 253, 245, 0.98), rgba(255, 255, 255, 0.98));
}

.bb-modal-guidance strong {
  font-size: 13px;
  line-height: 1.2;
}

.bb-modal-guidance span {
  color: var(--bb-muted);
  font-size: 11px;
  line-height: 1.45;
}

.bb-group {
  display: grid;
  gap: 7px;
  padding: 9px;
  border: 1px solid var(--bb-border-soft);
  border-radius: 22px;
  background: var(--bb-bg-elevated);
}

.bb-group--featured {
  grid-column: 1 / -1;
  padding: 12px;
  border-color: rgba(23, 155, 109, 0.18);
  background: linear-gradient(180deg, rgba(236, 253, 245, 0.96), rgba(255, 255, 255, 0.98));
}

.bb-group--lanes {
  padding: 12px;
}

.bb-group--hero {
  border-color: rgba(23, 155, 109, 0.28);
  box-shadow: none;
}

.bb-group--optional {
  background: var(--bb-bg-soft);
}

.bb-group-header {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 12px;
}

.bb-group-header--stacked {
  align-items: center;
}

.bb-group-header--hero {
  padding: 2px 2px 4px;
}

.bb-group-header--stacked span {
  background: rgba(23, 155, 109, 0.12);
  color: var(--bb-brand-deep);
}

.bb-group-header h4 {
  margin: 0;
  font-size: 13px;
  line-height: 1.2;
}

.bb-group-header p {
  margin: 4px 0 0;
  color: var(--bb-muted);
  font-size: 11px;
  line-height: 1.35;
}

.bb-group-header span {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  color: var(--bb-brand-deep);
  background: var(--bb-bg-soft);
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.bb-group-grid {
  display: grid;
  gap: 6px;
}

.bb-condition-lanes {
  display: grid;
  gap: 10px;
}

.bb-condition-lane {
  display: grid;
  gap: 10px;
  padding: 12px;
  border-radius: 20px;
  border: 1px solid rgba(23, 155, 109, 0.14);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(236, 253, 245, 0.92));
  box-shadow: none;
}

.bb-condition-lane-head {
  display: flex;
  align-items: start;
  justify-content: space-between;
  gap: 12px;
}

.bb-condition-lane-head strong {
  display: block;
  font-size: 13px;
  line-height: 1.2;
}

.bb-condition-lane-head p {
  margin: 4px 0 0;
  color: var(--bb-muted);
  font-size: 11px;
  line-height: 1.4;
}

.bb-condition-lane-head span {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  color: var(--bb-brand-deep);
  background: rgba(23, 155, 109, 0.12);
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.bb-condition-lane-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.bb-condition-lane-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bb-group-empty {
  padding: 10px;
  border-radius: 16px;
  color: var(--bb-muted);
  font-size: 12px;
  border: 1px dashed var(--bb-border-soft);
  background: var(--bb-bg-soft);
}

.bb-template-card {
  display: grid;
  gap: 6px;
  width: 100%;
  padding: 10px;
  text-align: left;
  color: var(--bb-text);
  cursor: pointer;
  border-radius: 20px;
  border: 1px solid var(--bb-border-soft);
  background: var(--bb-bg-elevated);
  transition:
    transform 0.18s ease,
    border-color 0.18s ease,
    background 0.18s ease;
}

.bb-template-card:hover,
.bb-template-card.is-selected {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--template-accent) 45%, transparent);
  background: var(--bb-bg-soft);
}

.bb-template-card--featured {
  border-color: rgba(23, 155, 109, 0.18);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(236, 253, 245, 0.94));
}

.bb-group--featured .bb-template-card {
  border-color: rgba(23, 155, 109, 0.18);
}

.bb-group--optional .bb-template-card {
  opacity: 0.96;
}

.bb-template-title strong {
  display: block;
  font-size: 12px;
}

.bb-template-title small {
  display: block;
  margin-top: 3px;
  color: var(--bb-muted);
  line-height: 1.35;
  font-size: 10px;
}

.bb-template-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.bb-chip {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  color: #475569;
  background: var(--bb-bg-soft);
  border: 1px solid var(--bb-border-soft);
  font-size: 8px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.bb-modal-detail {
  display: grid;
  align-content: start;
  gap: 10px;
  padding: 10px;
  border-radius: 18px;
  border: 1px solid var(--bb-border-soft);
  background: linear-gradient(180deg, var(--bb-bg-soft), color-mix(in srgb, var(--bb-bg-soft) 85%, white));
}

.bb-modal-empty {
  color: var(--bb-muted);
  line-height: 1.55;
}

.bb-detail-head {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: flex-start;
}

.bb-detail-head h4 {
  margin: 4px 0 5px;
  font-size: 14px;
}

.bb-detail-head p {
  margin: 0;
  color: var(--bb-muted);
  line-height: 1.4;
  font-size: 11px;
}

.bb-detail-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  color: var(--bb-brand-deep);
  background: var(--bb-bg-elevated);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 9px;
  font-weight: 800;
}

.bb-detail-form {
  display: grid;
  gap: 8px;
}

.bb-field {
  display: grid;
  gap: 7px;
}

.bb-field > label {
  color: var(--bb-muted);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.bb-field-block__body input[type="text"],
.bb-field-block__body input[type="number"],
.bb-field-block__body select {
  min-height: 34px;
  width: 100%;
  padding: 0 10px;
  color: var(--bb-text);
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border-soft);
  border-radius: 16px;
  outline: none;
  box-shadow: none;
}

.bb-field-block__body input[type="text"]::placeholder {
  color: var(--bb-faint);
}

.bb-check {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-height: 30px;
  color: var(--bb-text);
  font-size: 11px;
  text-transform: none;
  letter-spacing: 0;
}

.bb-check input {
  width: 18px;
  height: 18px;
  accent-color: var(--bb-execution);
}

.bb-radio-group {
  display: grid;
  gap: 5px;
}

.bb-radio-option {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 9px;
  border-radius: 12px;
  color: var(--bb-text);
  background: var(--bb-bg-elevated);
  border: 1px solid var(--bb-border-soft);
}

.bb-radio-option input {
  accent-color: var(--bb-brand);
}

.bb-field-block {
  position: relative;
  display: grid;
  gap: 0;
  overflow: hidden;
  border-radius: var(--block-radius);
  border: 1px solid var(--block-border);
  background: linear-gradient(180deg, var(--block-body-bg), var(--block-body-alt));
  box-shadow: none;
}

.bb-field-block::before,
.bb-field-block::after {
  content: "";
  position: absolute;
  left: 50%;
  width: 36px;
  height: 12px;
  transform: translateX(-50%);
  background: var(--block-body-alt);
  border: 1px solid var(--block-border);
  pointer-events: none;
}

.bb-field-block::before {
  top: -7px;
  border-bottom: 0;
  border-radius: 0 0 999px 999px;
}

.bb-field-block::after {
  bottom: -7px;
  border-top: 0;
  border-radius: 999px 999px 0 0;
}

.bb-field-block__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 28px;
  padding: 0 10px;
  color: var(--block-header-fg);
  background: linear-gradient(180deg, var(--block-header-bg), color-mix(in srgb, var(--block-header-bg) 84%, black));
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.bb-field-block__bar small {
  color: rgba(255, 255, 255, 0.82);
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: none;
}

.bb-field-block__body {
  display: grid;
  gap: 8px;
  padding: 10px 10px 11px;
}

.bb-field-block.is-checkbox .bb-field-block__body {
  padding-top: 8px;
}

.bb-field-block.is-radio .bb-field-block__body {
  gap: 6px;
}

.bb-field-block + .bb-field-block {
  margin-top: 2px;
}

.bb-detail-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 2px;
}

.bb-detail-actions .bb-btn {
  min-width: 112px;
  min-height: 34px;
  padding: 0 10px;
  font-size: 11px;
}

.bb-btn.is-muted {
  opacity: 0.72;
}

.blocklyWidgetDiv,
.blocklyTooltipDiv {
  z-index: 200 !important;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.28);
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: content-box;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(148, 163, 184, 0.42);
  background-clip: content-box;
}

@media (max-width: 1320px) {
  .bb-layout {
    grid-template-columns: 260px minmax(0, 1fr);
  }

  .bb-inspector {
    grid-column: 1 / -1;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 980px) {
  body {
    overflow: auto;
  }

  .bb-app {
    height: auto;
    min-height: 100svh;
  }

  .bb-topbar {
    align-items: stretch;
  }

  .bb-topbar-center {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .bb-topbar-status,
  .bb-topbar-actions {
    margin-left: 0;
  }

  .bb-layout {
    grid-template-columns: 1fr;
  }

  .bb-sidebar,
  .bb-inspector {
    grid-template-columns: 1fr;
  }

  .bb-workspace-shell {
    min-height: 62vh;
  }

  .bb-modal-shell {
    position: fixed;
    top: 10px;
    left: 10px;
    width: calc(100vw - 20px);
    height: calc(100vh - 20px);
    margin: 0;
  }

  .bb-modal-body {
    grid-template-columns: 1fr;
  }

  .bb-modal-list,
  .bb-category-groups {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,yCAAyC;EACzC,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,kCAAkC;EAClC,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,sCAAsC;EACtC,oBAAoB;EACpB,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mCAAmC;EACnC,sCAAsC;EACtC,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,yCAAyC;EACzC,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,qBAAqB;EACrB;;;gGAG8F;EAC9F,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uCAAuC;EACvC,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,8CAA8C;EAC9C,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kFAAkF;EAClF,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,gCAAgC;EAChC,sEAAsE;AACxE;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,6EAA6E;AAC/E;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+EAA+E;EAC/E,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;;EAGE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,MAAM;AACR;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,MAAM;EACN,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,iFAAiF;EACjF,eAAe;EACf;;;yBAGuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,yEAAyE;EACzE,iFAAiF;AACnF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,kEAAkE;AACpE;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,gFAAgF;EAChF,mBAAmB;EACnB;;;;;;uEAMqE;EACrE,6DAA6D;EAC7D,uDAAuD;EACvD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,gGAAgG;AAChG;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,wEAAwE;AAC1E;;AAEA;EACE,sCAAsC;EACtC,wEAAwE;AAC1E;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,sCAAsC;EACtC,yCAAyC;EACzC,OAAO;EACP,OAAO;AACT;;AAEA;;;EAGE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gDAAgD;AAClD;;AAEA;;;;;;;EAOE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;AAC3F;;AAEA;EACE,qCAAqC;EACrC,yFAAyF;AAC3F;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,uCAAuC;EACvC,SAAS;EACT,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,yFAAyF;AAC3F;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,yFAAyF;AAC3F;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yFAAyF;EACzF,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,iCAAiC;EACjC;;;yBAGuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,yEAAyE;EACzE,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,yFAAyF;AAC3F;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,6BAA6B;EAC7B,uCAAuC;EACvC,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,wGAAwG;AAC1G;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iCAAiC;EACjC,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,gFAAgF;EAChF,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;EACjC,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,kHAAkH;EAClH,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,mBAAmB;IACnB,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,UAAU;IACV,yBAAyB;IACzB,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap\");\n\n:root {\n  color-scheme: light;\n  --bb-bg: #eef5f1;\n  --bb-bg-elevated: #ffffff;\n  --bb-bg-soft: #f4f8f5;\n  --bb-bg-glass: rgba(255, 255, 255, 0.9);\n  --bb-border: rgba(20, 83, 45, 0.12);\n  --bb-border-soft: rgba(20, 83, 45, 0.1);\n  --bb-text: #102018;\n  --bb-muted: #5a6b62;\n  --bb-faint: #8a9a92;\n  --bb-brand: #179b6d;\n  --bb-brand-deep: #14532d;\n  --bb-brand-soft: rgba(23, 155, 109, 0.12);\n  --bb-market: #179b6d;\n  --bb-execution: #146c4c;\n  --bb-indicators: #0f766e;\n  --bb-conditions: #f59e0b;\n  --bb-restart: #8b5cf6;\n  --bb-utility: #5f6f68;\n  --bb-success: #16a34a;\n  --bb-warning: #facc15;\n  --bb-danger: #ef4444;\n  --bb-radius: 24px;\n  --bb-radius-sm: 18px;\n  --bb-radius-xs: 12px;\n  --block-header-bg: var(--bb-brand);\n  --block-header-fg: #ffffff;\n  --block-body-bg: #ffffff;\n  --block-body-alt: #f7fbf8;\n  --block-border: rgba(20, 83, 45, 0.12);\n  --block-radius: 10px;\n  --block-notch-size: 9px;\n  --block-shell-padding: 12px;\n  font-family: \"Manrope\", sans-serif;\n}\n\n:root.dark {\n  color-scheme: dark;\n  --bb-bg: #09140f;\n  --bb-bg-elevated: #0d1b15;\n  --bb-bg-soft: #102119;\n  --bb-bg-glass: rgba(9, 20, 15, 0.9);\n  --bb-border: rgba(167, 243, 208, 0.12);\n  --bb-border-soft: rgba(167, 243, 208, 0.08);\n  --bb-text: #e8f4ef;\n  --bb-muted: #9fb1a8;\n  --bb-faint: #72877d;\n  --bb-brand: #1db57f;\n  --bb-brand-deep: #169368;\n  --bb-brand-soft: rgba(29, 181, 127, 0.14);\n  --block-header-bg: #1db57f;\n  --block-header-fg: #08110d;\n  --block-body-bg: #0e1713;\n  --block-body-alt: #101c17;\n  --block-border: rgba(167, 243, 208, 0.14);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  width: 100%;\n  min-height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Manrope\", sans-serif;\n  color: var(--bb-text);\n  background:\n    radial-gradient(circle at top left, rgba(23, 155, 109, 0.12), transparent 28%),\n    radial-gradient(circle at top right, rgba(20, 83, 45, 0.08), transparent 24%),\n    linear-gradient(180deg, var(--bb-bg) 0%, color-mix(in srgb, var(--bb-bg) 88%, #ffffff) 100%);\n  overflow: hidden;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font: inherit;\n}\n\nbutton {\n  border: 0;\n}\n\n#app {\n  width: 100%;\n  height: 100svh;\n  min-height: 100svh;\n}\n\n.bb-app {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr);\n  gap: 0;\n  padding: 0;\n}\n\n.bb-topbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 18px;\n  border: 0;\n  border-bottom: 1px solid var(--bb-border-soft);\n  border-radius: 0;\n  background: var(--bb-bg-glass);\n  box-shadow: none;\n  backdrop-filter: none;\n}\n\n.bb-topbar-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.bb-brand-mark {\n  width: 44px;\n  height: 44px;\n  display: grid;\n  place-items: center;\n  border-radius: 18px;\n  color: #ffffff;\n  background: linear-gradient(180deg, var(--bb-brand) 0%, var(--bb-brand-deep) 100%);\n  font-weight: 800;\n  letter-spacing: 0.08em;\n}\n\n.bb-topbar-brand strong {\n  display: block;\n  font-size: 18px;\n  line-height: 1.1;\n}\n\n.bb-topbar-brand span {\n  display: block;\n  color: var(--bb-muted);\n  font-size: 12px;\n}\n\n.bb-topbar-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  flex: 1 1 320px;\n  min-width: 0;\n}\n\n.bb-market-picker {\n  display: grid;\n  gap: 6px;\n  min-width: 240px;\n}\n\n.bb-market-picker span {\n  color: var(--bb-muted);\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.bb-market-picker select {\n  width: 100%;\n  min-height: 42px;\n  padding: 0 14px;\n  color: var(--bb-text);\n  background: var(--bb-bg-elevated);\n  border: 1px solid var(--bb-border);\n  border-radius: 18px;\n  outline: none;\n  box-shadow: none;\n}\n\n.bb-market-picker input {\n  width: 100%;\n  min-height: 42px;\n  padding: 0 14px;\n  color: var(--bb-text);\n  background: var(--bb-bg-elevated);\n  border: 1px solid var(--bb-border);\n  border-radius: 18px;\n  outline: none;\n  box-shadow: none;\n}\n\n.bb-token-picker {\n  min-width: 280px;\n}\n\n.bb-topbar-status {\n  min-height: 42px;\n  display: inline-grid;\n  gap: 2px;\n  align-items: center;\n  padding: 8px 14px;\n  border-radius: 999px;\n  color: var(--bb-brand-deep);\n  background: var(--bb-brand-soft);\n  border: 1px solid color-mix(in srgb, var(--bb-brand) 22%, transparent);\n}\n\n.bb-topbar-status-label {\n  color: var(--bb-brand-deep);\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1.1;\n}\n\n.bb-topbar-status-label.is-ready {\n  color: var(--bb-brand-deep);\n}\n\n.bb-topbar-status-label.is-running {\n  color: var(--bb-brand);\n}\n\n.bb-topbar-status-label.is-error {\n  color: #991b1b;\n}\n\n.bb-topbar-status-note {\n  color: #4b5563;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.bb-topbar-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.bb-btn {\n  min-height: 42px;\n  padding: 0 16px;\n  border-radius: 16px;\n  cursor: pointer;\n  color: var(--block-header-fg);\n  font-weight: 800;\n  letter-spacing: 0.01em;\n  box-shadow: none;\n  transition: transform 0.18s ease, opacity 0.18s ease, border-color 0.18s ease;\n}\n\n.bb-btn-sm {\n  min-height: 34px;\n  padding: 0 12px;\n  border-radius: 12px;\n  font-size: 12px;\n}\n\n.bb-btn:hover {\n  transform: translateY(-1px);\n}\n\n.bb-btn:active {\n  transform: translateY(0);\n  opacity: 0.92;\n}\n\n.bb-btn-success {\n  background: var(--bb-brand);\n}\n\n.bb-btn-warn {\n  color: #ffffff;\n  background: #2f855a;\n}\n\n.bb-btn-primary {\n  background: var(--bb-brand);\n}\n\n.bb-btn-secondary {\n  background: #64748b;\n}\n\n.bb-btn-danger {\n  background: #ef4444;\n}\n\n.bb-layout {\n  display: grid;\n  grid-template-columns: minmax(208px, 238px) minmax(0, 1fr) minmax(248px, 294px);\n  gap: 16px;\n  padding: 14px 16px 0;\n  min-height: 0;\n  align-items: stretch;\n}\n\n.bb-sidebar,\n.bb-inspector {\n  display: grid;\n  gap: 14px;\n  align-content: start;\n  min-height: 0;\n}\n\n.bb-panel,\n.bb-card {\n  padding: 16px;\n  border: 1px solid var(--bb-border-soft);\n  border-radius: 24px;\n  background: var(--bb-bg-glass);\n  box-shadow: none;\n}\n\n.bb-sidebar-intro p,\n.bb-sidebar-footnote p,\n.bb-tip-card p {\n  margin: 0;\n  color: var(--bb-muted);\n  line-height: 1.55;\n  font-size: 13px;\n}\n\n.bb-panel-title,\n.bb-card-title {\n  margin-bottom: 12px;\n  color: #111827;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 800;\n}\n\n.bb-category-list {\n  display: grid;\n  gap: 10px;\n}\n\n.bb-category-accordion {\n  display: grid;\n  gap: 0;\n}\n\n.bb-category-card {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0;\n  align-items: center;\n  width: 100%;\n  padding: 12px 13px;\n  color: var(--bb-text);\n  text-align: left;\n  border: 1px solid var(--bb-border-soft);\n  border-radius: 18px;\n  background: linear-gradient(180deg, var(--bb-bg-elevated), var(--block-body-alt));\n  cursor: pointer;\n  transition:\n    transform 0.18s ease,\n    border-color 0.18s ease,\n    background 0.18s ease;\n}\n\n.bb-category-card:hover,\n.bb-category-card.is-active {\n  transform: translateY(-1px);\n  border-color: color-mix(in srgb, var(--category-accent) 48%, transparent);\n  background: linear-gradient(180deg, var(--bb-bg-elevated), var(--block-body-alt));\n}\n\n.bb-category-card.is-active {\n  box-shadow: none;\n}\n\n.bb-category-copy strong {\n  display: block;\n  font-size: 15px;\n}\n\n\n.bb-workbench {\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr);\n  gap: 14px;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n}\n\n.bb-workbench-header {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 18px;\n  padding: 8px 8px 0;\n}\n\n.bb-workbench-kicker {\n  color: var(--bb-brand);\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.bb-workbench-header h2 {\n  margin: 6px 0 6px;\n  font-size: 22px;\n  line-height: 1.1;\n}\n\n.bb-workbench-header p {\n  margin: 0;\n  max-width: 62ch;\n  color: var(--bb-muted);\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.bb-workbench-flow {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.bb-workbench-flow span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 34px;\n  padding: 0 12px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 900;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  border: 1px solid transparent;\n}\n\n.bb-workbench-flow .is-market {\n  color: var(--bb-brand-deep);\n  background: var(--bb-brand-soft);\n  border-color: color-mix(in srgb, var(--bb-brand) 18%, transparent);\n}\n\n.bb-workbench-flow .is-execution {\n  color: #14532d;\n  background: rgba(20, 83, 45, 0.08);\n  border-color: rgba(20, 83, 45, 0.18);\n}\n\n.bb-workbench-flow .is-conditions {\n  color: #92400e;\n  background: rgba(245, 158, 11, 0.1);\n  border-color: rgba(245, 158, 11, 0.18);\n}\n\n.bb-workbench-flow .is-restart {\n  color: #5b6472;\n  background: rgba(148, 163, 184, 0.12);\n  border-color: rgba(148, 163, 184, 0.2);\n}\n\n.bb-workspace-shell {\n  position: relative;\n  min-height: 0;\n  height: 100%;\n  min-height: clamp(560px, 66svh, 860px);\n  padding: 12px;\n  border: 1px solid color-mix(in srgb, var(--bb-brand) 14%, var(--bb-border-soft));\n  border-radius: 28px;\n  background:\n    radial-gradient(circle at top left, rgba(23, 155, 109, 0.1), transparent 26%),\n    radial-gradient(circle at top right, rgba(20, 83, 45, 0.08), transparent 22%),\n    radial-gradient(circle at bottom left, rgba(245, 158, 11, 0.05), transparent 20%),\n    linear-gradient(180deg, color-mix(in srgb, var(--bb-bg) 94%, #ffffff) 0%, color-mix(in srgb, var(--bb-bg) 84%, #ffffff) 48%, color-mix(in srgb, var(--bb-bg) 78%, #ffffff) 100%),\n    linear-gradient(rgba(15, 23, 42, 0.03) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(15, 23, 42, 0.03) 1px, transparent 1px);\n  background-size: auto, auto, auto, auto, 38px 38px, 38px 38px;\n  background-position: 0 0, 100% 100%, 0 0, 0 0, 0 0, 0 0;\n  box-shadow: none;\n  overflow: hidden;\n}\n\n.bb-workspace {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  border-radius: 22px;\n  touch-action: none;\n}\n\n.bb-workspace .blocklyMainBackground {\n  fill: rgba(255, 255, 255, 0.68) !important;\n}\n\n.bb-workspace .blocklySvg {\n  border-radius: 24px;\n}\n\n.bb-workspace .blocklyToolboxDiv,\n.bb-workspace .blocklyFlyout,\n.bb-workspace .blocklyFlyoutBackground {\n  display: none !important;\n}\n\n.bb-workspace .blocklyScrollbarVertical,\n.bb-workspace .blocklyScrollbarHorizontal {\n  opacity: 0.78;\n}\n\n.bb-workspace .blocklyFlyoutBackground {\n  fill: rgba(255, 255, 255, 0.92) !important;\n}\n\n/* Keep Blockly's puzzle geometry, but give each block the layered Deriv-style card treatment. */\n.bb-workspace .bb-block .blocklyPath {\n  stroke-width: 1.2px !important;\n  vector-effect: non-scaling-stroke;\n}\n\n.bb-workspace .bb-block-section .blocklyPath {\n  fill: var(--bb-brand-deep) !important;\n  stroke: color-mix(in srgb, var(--bb-brand-deep) 82%, #06130d) !important;\n}\n\n.bb-workspace .bb-block-card .blocklyPath {\n  fill: var(--block-body-alt) !important;\n  stroke: color-mix(in srgb, var(--bb-brand-deep) 28%, #ffffff) !important;\n}\n\n.bb-workspace .bb-block-section .blocklyText {\n  fill: #ffffff !important;\n  font-family: \"Manrope\", sans-serif !important;\n  font-weight: 700 !important;\n}\n\n.bb-workspace .bb-block-card .blocklyText {\n  fill: var(--bb-text) !important;\n  font-family: \"Manrope\", sans-serif !important;\n  font-weight: 700 !important;\n}\n\n.bb-workspace .bb-block-section .blocklyText {\n  font-size: 11px !important;\n  letter-spacing: 0.02em;\n}\n\n.bb-workspace .bb-block-card .blocklyText {\n  font-size: 10px !important;\n}\n\n.bb-workspace .bb-block .blocklyEditableText rect,\n.bb-workspace .bb-block .blocklyFieldRect {\n  fill: var(--bb-bg-elevated) !important;\n  stroke: rgba(20, 83, 45, 0.18) !important;\n  rx: 5px;\n  ry: 5px;\n}\n\n.bb-workspace .bb-block .blocklyEditableText text,\n.bb-workspace .bb-block .blocklyDropdownText,\n.bb-workspace .bb-block .blocklyCheckboxText {\n  fill: var(--bb-text) !important;\n  font-weight: 700 !important;\n}\n\n.bb-workspace .bb-block .blocklyDropdownArrow {\n  fill: var(--bb-brand-deep) !important;\n}\n\n.bb-workspace .bb-block .blocklyConnectionIndicator,\n.bb-workspace .bb-block .blocklyConnectionHighlight {\n  stroke: var(--bb-warning) !important;\n}\n\n.bb-workspace .bb-block.blocklySelected .blocklyPath {\n  stroke: var(--bb-warning) !important;\n  stroke-width: 2.4px !important;\n}\n\n.bb-workspace .bb-block:not(.bb-block-section) {\n  filter: none;\n}\n\n:root.dark .bb-workspace .bb-block .blocklyEditableText rect,\n:root.dark .bb-workspace .bb-block .blocklyFieldRect {\n  stroke: rgba(167, 243, 208, 0.22) !important;\n}\n\n.bb-inspector {\n  min-height: 0;\n  overflow-y: auto;\n  scrollbar-gutter: stable;\n  padding-right: 4px;\n}\n\n.bb-status-pill {\n  display: inline-flex;\n  align-items: center;\n  min-height: 36px;\n  padding: 0 14px;\n  border-radius: 999px;\n  font-weight: 800;\n  letter-spacing: 0.01em;\n}\n\n.bb-status-pill.is-ready {\n  color: #14532d;\n  background: rgba(220, 252, 231, 0.72);\n  border: 1px solid rgba(22, 163, 74, 0.26);\n}\n\n.bb-status-pill.is-error {\n  color: #991b1b;\n  background: rgba(254, 226, 226, 0.9);\n  border: 1px solid rgba(239, 68, 68, 0.24);\n}\n\n.bb-status-caption {\n  margin-top: 12px;\n  color: var(--bb-muted);\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.bb-condition-engine {\n  display: grid;\n  gap: 10px;\n  color: var(--bb-text);\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.bb-engine-summary {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.bb-engine-summary > div,\n.bb-engine-hint,\n.bb-engine-empty,\n.bb-engine-warning-list,\n.bb-engine-row,\n.bb-engine-detail,\n.bb-engine-warning {\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  background: var(--bb-bg-elevated);\n}\n\n.bb-engine-summary strong,\n.bb-engine-row strong {\n  display: block;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 4px;\n}\n\n.bb-engine-rules {\n  display: grid;\n  gap: 8px;\n}\n\n.bb-engine-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  margin-top: -2px;\n  color: var(--bb-muted);\n  font-size: 11px;\n}\n\n.bb-engine-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.bb-engine-row.is-ready {\n  border-color: rgba(22, 163, 74, 0.2);\n  background: rgba(220, 252, 231, 0.5);\n}\n\n.bb-engine-row.is-running {\n  border-color: rgba(23, 155, 109, 0.2);\n  background: rgba(236, 253, 245, 0.7);\n}\n\n.bb-engine-row.is-error {\n  border-color: rgba(239, 68, 68, 0.18);\n  background: rgba(254, 226, 226, 0.55);\n}\n\n.bb-engine-detail,\n.bb-engine-warning {\n  margin-top: 6px;\n  color: var(--bb-muted);\n}\n\n.bb-engine-warning {\n  color: #b45309;\n  background: rgba(254, 243, 199, 0.75);\n}\n\n.bb-engine-blocked {\n  display: grid;\n  gap: 8px;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(239, 68, 68, 0.18);\n  background: rgba(254, 226, 226, 0.45);\n}\n\n.bb-engine-blocked-title {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 900;\n  color: #991b1b;\n}\n\n.bb-engine-blocked-row {\n  display: grid;\n  gap: 4px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.72);\n}\n\n.bb-engine-blocked-row strong {\n  font-size: 12px;\n}\n\n.bb-engine-warning-list {\n  display: grid;\n  gap: 6px;\n  color: #92400e;\n  background: rgba(254, 243, 199, 0.45);\n}\n\n.bb-pre {\n  margin: 0;\n  max-height: 200px;\n  overflow: auto;\n  padding: 14px;\n  color: #111827;\n  white-space: pre-wrap;\n  word-break: break-word;\n  font-size: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  background: var(--bb-bg-soft);\n}\n\n.bb-results {\n  min-height: 84px;\n  padding: 14px;\n  border-radius: 14px;\n  color: var(--bb-text);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  background: var(--bb-bg-soft);\n}\n\n.bb-final-banner {\n  display: grid;\n  gap: 6px;\n  margin-bottom: 14px;\n  padding: 14px 16px;\n  border-radius: 16px;\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  background: rgba(255, 255, 255, 0.96);\n}\n\n.bb-final-banner-label {\n  font-size: 14px;\n  font-weight: 900;\n  letter-spacing: 0.02em;\n}\n\n.bb-final-banner-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  color: var(--bb-muted);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.bb-final-banner.is-ready {\n  border-color: rgba(22, 163, 74, 0.24);\n  background: linear-gradient(180deg, rgba(220, 252, 231, 0.95), rgba(255, 255, 255, 0.98));\n}\n\n.bb-final-banner.is-error {\n  border-color: rgba(239, 68, 68, 0.24);\n  background: linear-gradient(180deg, rgba(254, 226, 226, 0.95), rgba(255, 255, 255, 0.98));\n}\n\n.bb-trade-summary {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.bb-trade-summary-item {\n  display: grid;\n  gap: 6px;\n  padding: 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(20, 83, 45, 0.12);\n  background: rgba(255, 255, 255, 0.94);\n}\n\n.bb-trade-summary-item span {\n  color: var(--bb-muted);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.bb-trade-summary-item strong {\n  color: var(--bb-text);\n  font-size: 14px;\n  font-weight: 800;\n}\n\n.bb-trade-summary-badge {\n  display: inline-flex;\n  width: fit-content;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.bb-trade-summary-badge.is-ready {\n  color: #14532d;\n  background: rgba(220, 252, 231, 0.9);\n}\n\n.bb-trade-summary-badge.is-running {\n  color: var(--bb-brand-deep);\n  background: rgba(236, 253, 245, 0.9);\n}\n\n.bb-trade-summary-badge.is-error {\n  color: #991b1b;\n  background: rgba(254, 226, 226, 0.9);\n}\n\n.bb-result-ok {\n  color: var(--bb-brand);\n  font-weight: 800;\n}\n\n.bb-result-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.bb-result-outcome {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 900;\n  letter-spacing: 0.02em;\n}\n\n.bb-result-outcome.is-ready {\n  color: #14532d;\n  background: rgba(220, 252, 231, 0.9);\n}\n\n.bb-result-outcome.is-running {\n  color: var(--bb-brand-deep);\n  background: rgba(236, 253, 245, 0.9);\n}\n\n.bb-result-outcome.is-error {\n  color: #991b1b;\n  background: rgba(254, 226, 226, 0.9);\n}\n\n.bb-result-error {\n  color: #fecaca;\n  font-weight: 800;\n}\n\n.bb-result-meta {\n  display: grid;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.bb-result-meta div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  color: var(--bb-muted);\n  font-size: 12px;\n}\n\n.bb-result-meta strong {\n  color: #e2e8f0;\n  font-size: 12px;\n}\n\n.bb-result-list {\n  display: grid;\n  gap: 8px;\n  margin-top: 12px;\n  color: #fecaca;\n  font-size: 13px;\n}\n\n.bb-result-caption {\n  margin-top: 10px;\n  color: var(--bb-muted);\n  font-size: 13px;\n}\n\n.bb-settled-note {\n  margin-top: 14px;\n  padding: 12px 14px;\n  border-radius: 14px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n  background: rgba(236, 253, 245, 0.8);\n  border: 1px dashed rgba(23, 155, 109, 0.28);\n}\n\n.bb-lifecycle-list {\n  display: grid;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.bb-lifecycle-row {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 12px;\n  align-items: start;\n  padding: 12px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.62);\n  border: 1px solid rgba(20, 83, 45, 0.08);\n}\n\n.bb-lifecycle-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 84px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.bb-lifecycle-badge.is-ready {\n  color: #14532d;\n  background: rgba(220, 252, 231, 0.9);\n}\n\n.bb-lifecycle-badge.is-running {\n  color: var(--bb-brand-deep);\n  background: rgba(236, 253, 245, 0.9);\n}\n\n.bb-lifecycle-badge.is-pending {\n  color: #92400e;\n  background: #fef3c7;\n}\n\n.bb-lifecycle-body {\n  display: grid;\n  gap: 8px;\n}\n\n.bb-lifecycle-title {\n  color: var(--bb-text);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.bb-lifecycle-details {\n  margin-top: 2px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(20, 83, 45, 0.12);\n  background: rgba(255, 255, 255, 0.94);\n}\n\n.bb-lifecycle-details summary {\n  cursor: pointer;\n  color: var(--bb-muted);\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.bb-lifecycle-raw {\n  margin: 10px 0 0;\n  max-height: 220px;\n  overflow: auto;\n  padding: 12px;\n  border-radius: 12px;\n  background: #0b1712;\n  color: #e3f0ea;\n  font-size: 11px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.bb-event-log {\n  margin-top: 14px;\n  padding: 14px;\n  border-radius: 16px;\n  border: 1px solid rgba(20, 83, 45, 0.12);\n  background: rgba(255, 255, 255, 0.58);\n}\n\n.bb-event-log-title {\n  color: var(--bb-muted);\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.bb-event-log-list {\n  display: grid;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.bb-event-log-row {\n  display: grid;\n  gap: 6px;\n  padding: 10px 12px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(20, 83, 45, 0.1);\n}\n\n.bb-event-log-time,\n.bb-event-log-name {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.bb-event-log-time {\n  color: #64748b;\n}\n\n.bb-event-log-name {\n  color: var(--bb-brand);\n}\n\n.bb-event-log-payload {\n  margin: 0;\n  padding: 10px;\n  overflow: auto;\n  border-radius: 12px;\n  background: #0b1712;\n  color: #e3f0ea;\n  font-size: 11px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.bb-event-log-empty {\n  color: var(--bb-muted);\n  font-size: 12px;\n  font-style: italic;\n}\n\n.bb-tip-card p {\n  margin: 0;\n}\n\n.bb-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  display: none;\n}\n\n.bb-modal.is-open {\n  display: block;\n}\n\n.bb-modal-shell {\n  position: fixed;\n  top: 80px;\n  left: clamp(280px, 22vw, 380px);\n  width: min(520px, calc(100vw - 320px));\n  height: min(540px, calc(100vh - 110px));\n  margin: 0;\n  display: grid;\n  grid-template-rows: auto auto minmax(0, 1fr);\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid var(--bb-border);\n  border-radius: 26px;\n  background: var(--bb-bg-glass);\n  box-shadow: none;\n}\n\n.bb-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.bb-modal-kicker {\n  color: var(--bb-brand);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.bb-modal-header h3 {\n  margin: 6px 0 4px;\n  font-size: 18px;\n}\n\n.bb-modal-header p {\n  margin: 0;\n  max-width: 52ch;\n  color: var(--bb-muted);\n  line-height: 1.45;\n  font-size: 12px;\n}\n\n.bb-icon-btn {\n  min-height: 40px;\n  padding: 0 14px;\n  border-radius: 14px;\n  color: var(--bb-text);\n  cursor: pointer;\n  background: var(--bb-bg-elevated);\n  border: 1px solid var(--bb-border);\n}\n\n.bb-modal-toolbar {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.bb-search {\n  display: grid;\n  gap: 6px;\n  flex: 1;\n}\n\n.bb-search span {\n  color: var(--bb-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.bb-search input {\n  min-height: 40px;\n  padding: 0 14px;\n  color: var(--bb-text);\n  background: var(--bb-bg-elevated);\n  border: 1px solid var(--bb-border);\n  border-radius: 18px;\n  outline: none;\n}\n\n.bb-modal-count {\n  color: var(--bb-muted);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.bb-modal-body {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(180px, 0.42fr);\n  gap: 8px;\n  min-height: 0;\n}\n\n.bb-modal-list,\n.bb-modal-detail {\n  min-height: 0;\n  overflow: auto;\n  padding-right: 2px;\n}\n\n.bb-modal-list {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.bb-modal-guidance {\n  grid-column: 1 / -1;\n  display: grid;\n  gap: 3px;\n  padding: 12px 14px;\n  border: 1px solid rgba(23, 155, 109, 0.22);\n  border-radius: 20px;\n  background: linear-gradient(180deg, rgba(236, 253, 245, 0.98), rgba(255, 255, 255, 0.98));\n}\n\n.bb-modal-guidance strong {\n  font-size: 13px;\n  line-height: 1.2;\n}\n\n.bb-modal-guidance span {\n  color: var(--bb-muted);\n  font-size: 11px;\n  line-height: 1.45;\n}\n\n.bb-group {\n  display: grid;\n  gap: 7px;\n  padding: 9px;\n  border: 1px solid var(--bb-border-soft);\n  border-radius: 22px;\n  background: var(--bb-bg-elevated);\n}\n\n.bb-group--featured {\n  grid-column: 1 / -1;\n  padding: 12px;\n  border-color: rgba(23, 155, 109, 0.18);\n  background: linear-gradient(180deg, rgba(236, 253, 245, 0.96), rgba(255, 255, 255, 0.98));\n}\n\n.bb-group--lanes {\n  padding: 12px;\n}\n\n.bb-group--hero {\n  border-color: rgba(23, 155, 109, 0.28);\n  box-shadow: none;\n}\n\n.bb-group--optional {\n  background: var(--bb-bg-soft);\n}\n\n.bb-group-header {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.bb-group-header--stacked {\n  align-items: center;\n}\n\n.bb-group-header--hero {\n  padding: 2px 2px 4px;\n}\n\n.bb-group-header--stacked span {\n  background: rgba(23, 155, 109, 0.12);\n  color: var(--bb-brand-deep);\n}\n\n.bb-group-header h4 {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.2;\n}\n\n.bb-group-header p {\n  margin: 4px 0 0;\n  color: var(--bb-muted);\n  font-size: 11px;\n  line-height: 1.35;\n}\n\n.bb-group-header span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  padding: 0 10px;\n  border-radius: 999px;\n  color: var(--bb-brand-deep);\n  background: var(--bb-bg-soft);\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.bb-group-grid {\n  display: grid;\n  gap: 6px;\n}\n\n.bb-condition-lanes {\n  display: grid;\n  gap: 10px;\n}\n\n.bb-condition-lane {\n  display: grid;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 20px;\n  border: 1px solid rgba(23, 155, 109, 0.14);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(236, 253, 245, 0.92));\n  box-shadow: none;\n}\n\n.bb-condition-lane-head {\n  display: flex;\n  align-items: start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.bb-condition-lane-head strong {\n  display: block;\n  font-size: 13px;\n  line-height: 1.2;\n}\n\n.bb-condition-lane-head p {\n  margin: 4px 0 0;\n  color: var(--bb-muted);\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n.bb-condition-lane-head span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 26px;\n  padding: 0 10px;\n  border-radius: 999px;\n  color: var(--bb-brand-deep);\n  background: rgba(23, 155, 109, 0.12);\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.bb-condition-lane-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.bb-condition-lane-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.bb-group-empty {\n  padding: 10px;\n  border-radius: 16px;\n  color: var(--bb-muted);\n  font-size: 12px;\n  border: 1px dashed var(--bb-border-soft);\n  background: var(--bb-bg-soft);\n}\n\n.bb-template-card {\n  display: grid;\n  gap: 6px;\n  width: 100%;\n  padding: 10px;\n  text-align: left;\n  color: var(--bb-text);\n  cursor: pointer;\n  border-radius: 20px;\n  border: 1px solid var(--bb-border-soft);\n  background: var(--bb-bg-elevated);\n  transition:\n    transform 0.18s ease,\n    border-color 0.18s ease,\n    background 0.18s ease;\n}\n\n.bb-template-card:hover,\n.bb-template-card.is-selected {\n  transform: translateY(-1px);\n  border-color: color-mix(in srgb, var(--template-accent) 45%, transparent);\n  background: var(--bb-bg-soft);\n}\n\n.bb-template-card--featured {\n  border-color: rgba(23, 155, 109, 0.18);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(236, 253, 245, 0.94));\n}\n\n.bb-group--featured .bb-template-card {\n  border-color: rgba(23, 155, 109, 0.18);\n}\n\n.bb-group--optional .bb-template-card {\n  opacity: 0.96;\n}\n\n.bb-template-title strong {\n  display: block;\n  font-size: 12px;\n}\n\n.bb-template-title small {\n  display: block;\n  margin-top: 3px;\n  color: var(--bb-muted);\n  line-height: 1.35;\n  font-size: 10px;\n}\n\n.bb-template-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.bb-chip {\n  display: inline-flex;\n  align-items: center;\n  min-height: 20px;\n  padding: 0 7px;\n  border-radius: 999px;\n  color: #475569;\n  background: var(--bb-bg-soft);\n  border: 1px solid var(--bb-border-soft);\n  font-size: 8px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.bb-modal-detail {\n  display: grid;\n  align-content: start;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 18px;\n  border: 1px solid var(--bb-border-soft);\n  background: linear-gradient(180deg, var(--bb-bg-soft), color-mix(in srgb, var(--bb-bg-soft) 85%, white));\n}\n\n.bb-modal-empty {\n  color: var(--bb-muted);\n  line-height: 1.55;\n}\n\n.bb-detail-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.bb-detail-head h4 {\n  margin: 4px 0 5px;\n  font-size: 14px;\n}\n\n.bb-detail-head p {\n  margin: 0;\n  color: var(--bb-muted);\n  line-height: 1.4;\n  font-size: 11px;\n}\n\n.bb-detail-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 0 8px;\n  border-radius: 999px;\n  color: var(--bb-brand-deep);\n  background: var(--bb-bg-elevated);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 9px;\n  font-weight: 800;\n}\n\n.bb-detail-form {\n  display: grid;\n  gap: 8px;\n}\n\n.bb-field {\n  display: grid;\n  gap: 7px;\n}\n\n.bb-field > label {\n  color: var(--bb-muted);\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.bb-field-block__body input[type=\"text\"],\n.bb-field-block__body input[type=\"number\"],\n.bb-field-block__body select {\n  min-height: 34px;\n  width: 100%;\n  padding: 0 10px;\n  color: var(--bb-text);\n  background: var(--bb-bg-elevated);\n  border: 1px solid var(--bb-border-soft);\n  border-radius: 16px;\n  outline: none;\n  box-shadow: none;\n}\n\n.bb-field-block__body input[type=\"text\"]::placeholder {\n  color: var(--bb-faint);\n}\n\n.bb-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  min-height: 30px;\n  color: var(--bb-text);\n  font-size: 11px;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n.bb-check input {\n  width: 18px;\n  height: 18px;\n  accent-color: var(--bb-execution);\n}\n\n.bb-radio-group {\n  display: grid;\n  gap: 5px;\n}\n\n.bb-radio-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 9px;\n  border-radius: 12px;\n  color: var(--bb-text);\n  background: var(--bb-bg-elevated);\n  border: 1px solid var(--bb-border-soft);\n}\n\n.bb-radio-option input {\n  accent-color: var(--bb-brand);\n}\n\n.bb-field-block {\n  position: relative;\n  display: grid;\n  gap: 0;\n  overflow: hidden;\n  border-radius: var(--block-radius);\n  border: 1px solid var(--block-border);\n  background: linear-gradient(180deg, var(--block-body-bg), var(--block-body-alt));\n  box-shadow: none;\n}\n\n.bb-field-block::before,\n.bb-field-block::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  width: 36px;\n  height: 12px;\n  transform: translateX(-50%);\n  background: var(--block-body-alt);\n  border: 1px solid var(--block-border);\n  pointer-events: none;\n}\n\n.bb-field-block::before {\n  top: -7px;\n  border-bottom: 0;\n  border-radius: 0 0 999px 999px;\n}\n\n.bb-field-block::after {\n  bottom: -7px;\n  border-top: 0;\n  border-radius: 999px 999px 0 0;\n}\n\n.bb-field-block__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  min-height: 28px;\n  padding: 0 10px;\n  color: var(--block-header-fg);\n  background: linear-gradient(180deg, var(--block-header-bg), color-mix(in srgb, var(--block-header-bg) 84%, black));\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.bb-field-block__bar small {\n  color: rgba(255, 255, 255, 0.82);\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: none;\n}\n\n.bb-field-block__body {\n  display: grid;\n  gap: 8px;\n  padding: 10px 10px 11px;\n}\n\n.bb-field-block.is-checkbox .bb-field-block__body {\n  padding-top: 8px;\n}\n\n.bb-field-block.is-radio .bb-field-block__body {\n  gap: 6px;\n}\n\n.bb-field-block + .bb-field-block {\n  margin-top: 2px;\n}\n\n.bb-detail-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding-top: 2px;\n}\n\n.bb-detail-actions .bb-btn {\n  min-width: 112px;\n  min-height: 34px;\n  padding: 0 10px;\n  font-size: 11px;\n}\n\n.bb-btn.is-muted {\n  opacity: 0.72;\n}\n\n.blocklyWidgetDiv,\n.blocklyTooltipDiv {\n  z-index: 200 !important;\n}\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.28);\n  border-radius: 999px;\n  border: 2px solid transparent;\n  background-clip: content-box;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(148, 163, 184, 0.42);\n  background-clip: content-box;\n}\n\n@media (max-width: 1320px) {\n  .bb-layout {\n    grid-template-columns: 260px minmax(0, 1fr);\n  }\n\n  .bb-inspector {\n    grid-column: 1 / -1;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 980px) {\n  body {\n    overflow: auto;\n  }\n\n  .bb-app {\n    height: auto;\n    min-height: 100svh;\n  }\n\n  .bb-topbar {\n    align-items: stretch;\n  }\n\n  .bb-topbar-center {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n\n  .bb-topbar-status,\n  .bb-topbar-actions {\n    margin-left: 0;\n  }\n\n  .bb-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .bb-sidebar,\n  .bb-inspector {\n    grid-template-columns: 1fr;\n  }\n\n  .bb-workspace-shell {\n    min-height: 62vh;\n  }\n\n  .bb-modal-shell {\n    position: fixed;\n    top: 10px;\n    left: 10px;\n    width: calc(100vw - 20px);\n    height: calc(100vh - 20px);\n    margin: 0;\n  }\n\n  .bb-modal-body {\n    grid-template-columns: 1fr;\n  }\n\n  .bb-modal-list,\n  .bb-category-groups {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
